import * as React from 'react'

import { type MediumIcon } from '@factorialco/deprecated-design-system'

import Chip from 'modules/core/components/Filter/base/Chip'
import ChipWithIcon from 'modules/core/components/Filter/base/ChipWithIcon'
import ClearValue from 'modules/core/components/Filter/base/ClearValue'
import Content from 'modules/core/components/Filter/base/Content'
import Provider from 'modules/core/components/Filter/base/Provider'

type Props = {
  header?: React.ReactNode
  footer?: React.ReactNode
  label: string
  value?: unknown
  nameAttribute: string
  onValueChange: (value?: unknown) => void
  defaultOpen?: boolean
  icon?: MediumIcon
  noFooter?: boolean
  fullWidth?: boolean
  component: () => React.ReactNode
  composeActiveLabel?: (value: unknown) => string
}

const EntitySelectorFilter = ({
  header,
  label,
  value,
  nameAttribute,
  onValueChange,
  defaultOpen,
  icon,
  fullWidth,
  component,
  composeActiveLabel,
}: Props) => {
  const isNonEmptyArray = Array.isArray(value) && value.length > 0

  const getActiveLabel = () => {
    if (composeActiveLabel) return composeActiveLabel(value)

    if (isNonEmptyArray) {
      if (value.length > 1) return `(${value.length})`
      return value[0]?.[nameAttribute]
    }

    return ''
  }

  return (
    <Provider
      value={value}
      onValueChange={onValueChange}
      closeOnChange={false}
      defaultOpen={!!defaultOpen}
    >
      {icon ? (
        <ChipWithIcon label={label} activeLabel={getActiveLabel()} icon={icon} />
      ) : (
        <Chip.Toggler
          active={isNonEmptyArray}
          label={label}
          activeLabel={getActiveLabel()}
          fullWidth={fullWidth}
        />
      )}

      <Content
        header={header}
        body={component()}
        maxWidth="s"
        maxHeight="s600"
        footer={!value ? <ClearValue /> : undefined}
      />
    </Provider>
  )
}

export default EntitySelectorFilter
